module.exports = __webpack_public_path__ + "img/japanese-“monthly-amount”-button.1d074e8f.png";